import { Box, Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { RiCheckboxMultipleBlankLine } from "react-icons/ri";
import { TextGray } from "../../../components/Atomos/Texts/TextGray";

type Props = {
  icon: IconType;
  name: string;
  description: string;
  hasSubMenu: boolean;
  onClick: () => void;
};

export const DesktopMenuItem = ({
  icon,
  name,
  description,
  hasSubMenu,
  onClick
}: Props) => {
  const colorIcon = useColorModeValue("gray.300", "gray.300");
  const targetIcon = useColorModeValue("gray.500", "gray.400");
  const hoverColor = useColorModeValue(
    "rgba(0,0,0, 0.02)",
    "rgba(255,255,255, 0.03)"
  );

  return (
    <Box
      as="button"
      onClick={onClick}
      py="2"
      px="3"
      borderRadius="md"
      w="full"
      _hover={{
        bgColor: hoverColor
      }}
    >
      <Flex
        pr="1"
        alignItems="center"
        flex="1"
        fontSize="1rem"
        textAlign="left"
      >
        <Flex p={2} mr={3} borderRadius="lg">
          <Icon as={icon} fontSize="x-large" color={colorIcon} />
        </Flex>
        <Box lineHeight={1.3} w="full" pr={3}>
          <Text
            ml="0"
            fontSize="md"
            fontWeight="medium"
            maxW="230px"
            isTruncated
          >
            {name}
          </Text>
          <TextGray fontSize="sm" maxW="230px" isTruncated>
            {description}
          </TextGray>
        </Box>
        <Text fontSize="1rem" color={targetIcon}>
          {hasSubMenu ? <RiCheckboxMultipleBlankLine /> : null}
        </Text>
      </Flex>
    </Box>
  );
};
